import PropTypes from 'prop-types';

import { modifierList as iconsModifiersList } from '../../components/1-foundation/icons/props-list';
import { modifierList as sectionTitleModifiersList } from '../../components/2-atoms/section-title/props-list';
import { modifierList as cardModifiersList } from '../../components/3-molecules/card/props-list';

export default {
  htmlProps: PropTypes.shape({
    heading: PropTypes.string,
    intcmpArticle: PropTypes.string.isRequired,
    intcmpVideo: PropTypes.string,
    intcmpCta: PropTypes.string,
    target: PropTypes.string,
    position: PropTypes.string.isRequired,
    maxContents: PropTypes.number.isRequired,
    maxOptions: PropTypes.number.isRequired,
  }),
  widget: PropTypes.shape({
    name: PropTypes.string.isRequired,
    htmlId: PropTypes.string.isRequired,
    services: PropTypes.shape({
      query: PropTypes.string.isRequired,
      mutation: PropTypes.string.isRequired,
      mutationPrivacy: PropTypes.string.isRequired,
      subscription: PropTypes.string.isRequired,
    }).isRequired,
    tagSelectDefaultText: PropTypes.string.isRequired,
    isCtaActive: PropTypes.bool.isRequired,
    preferencesList: PropTypes.shape({
      message: PropTypes.string,
    }),
    loginCardText: PropTypes.string,
    styles: PropTypes.shape({
      setsOfCardsModifiers: PropTypes.string.isRequired,
      cardModifiers: PropTypes.shape({
        rail: PropTypes.arrayOf(PropTypes.oneOf(cardModifiersList)).isRequired,
      }).isRequired,
      iconsColor: PropTypes.oneOf(iconsModifiersList).isRequired,
      sectionTitleColor: PropTypes.oneOf(sectionTitleModifiersList).isRequired,
      sectionTitleActiveColor: PropTypes.oneOf(sectionTitleModifiersList).isRequired,
      skeletonColor: PropTypes.string.isRequired,
    }).isRequired,
    messageIdToShow: PropTypes.string,
  }).isRequired,
  $root: PropTypes.object,
  state: PropTypes.object.isRequired,
  parselyCommonState: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  pageActions: PropTypes.object,
  render: PropTypes.func.isRequired,
  useEffects: PropTypes.func.isRequired,
  isActiveInPage: PropTypes.bool,
  blockInPageType: PropTypes.string,
  showMoreText: PropTypes.string,
  showLessText: PropTypes.string,
  ctaPrimaryLabelInPage: PropTypes.string,
  confirmInPageMessage: PropTypes.string,
};
